import { captureSentryError } from '../../shared/sentry/sentryUser';

export type CustomerSyncedPayload = {
  customersCount: number;
  customerMovementsCount: number;
  salePaymentAllocationsCount: number;
};

type CustomerSyncedHandler = (payload: CustomerSyncedPayload) => void | Promise<void>;

const handlers = new Set<CustomerSyncedHandler>();

export function subscribeCustomerSynced(handler: CustomerSyncedHandler): () => void {
  handlers.add(handler);
  return () => handlers.delete(handler);
}

export function publishCustomerSynced(payload: CustomerSyncedPayload): void {
  for (const handler of handlers) {
    try {
      const result = handler(payload);
      if (result && typeof (result as Promise<void>).then === 'function') {
        void (result as Promise<void>).catch((error) => {
          captureSentryError(error, { tags: { module: 'sync', op: 'customer-synced-handler' } });
        });
      }
    } catch (error) {
      captureSentryError(error, { tags: { module: 'sync', op: 'customer-synced-handler' } });
    }
  }
}
